<div class="tile-progress bg-white text-left col-lg-12">
    <div class="col-lg-4" style="padding-left: 0%;">
        <label>Select Account</label>
        <ng-select [items]="accounts" name="accounts" bindLabel="accountName" [clearable]="false" [searchable]="true"
            bindValue="accountId" [(ngModel)]="accountId" placeholder="Select account">
        </ng-select>
    </div>
    <div class="col-lg-4" *ngIf="(accounts!=null && accountId>0)">
        <label>Select Module</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="allModules" name="screeningCenterList"
            [(ngModel)]="selectedModules" (onSelect)="onModuleChange($event, 'ADD')"
            (onDeSelect)="onModuleChange($event, 'REMOVE')" (onSelectAll)="onModuleChange($event, 'ADD_ALL')"
            (onDeSelectAll)="onModuleChange($event, 'REMOVE_ALL')">
        </ng-multiselect-dropdown>

    </div>
    <div class="col-lg-4" style="margin-top:27px;" *ngIf="(accounts!=null && accountId>0)">
        <button class="btn btn-sm btn-primary" (click)="getCustomFieldsByAccountId()">
            Select
        </button>
    </div>

</div>
<div
    *ngIf="(patientFields.customFields.length > 0 || patientFields.sections.length > 0) || (medicalInfoFields.customFields.length > 0 || medicalInfoFields.sections.length > 0) || (refractionFields.customFields.length > 0 || refractionFields.sections.length > 0)">
    <h4> Select the fields to be added in Import Patient Excel</h4>
</div>
<div class="row content-body tile-progress bg-white"
    *ngIf="(patientFields.customFields.length > 0 || patientFields.sections.length > 0)">
    <div>
        <div class="chiller_cb">
            <input type="checkbox" id="patientRegistrationAll" name="patientRegistrationAll"
                [(ngModel)]="allPatientRegistrationSelected" (change)="selectAllFields('patient-registration')" />
            <label style="font-size: 20px;" for="patientRegistrationAll">Patient Registration</label>
            <span></span>
        </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12" style="padding-left: 0px;padding-right: 0px;">
        <div *ngFor="let itr of patientFields.customFields; let fieldIndex=index">
            <div class="col-md-4 col-sm-12 col-xs-12" style="margin-top:10px">
                <div class="chiller_cb">
                    <input id="id_{{itr.id}}" name="id_{{itr.id}}" [(ngModel)]="itr.isSelected" type="checkbox" (click)="preventDeselect($event, itr)"/>
                    <label style="font-weight: normal;" for="id_{{itr.id}}">{{itr.fieldName}}<label
                            *ngIf="itr.isMandatory" style="color:red; padding-left: 0px !important;">*</label></label>
                    <span></span>
                </div>
            </div>
        </div>
        <div>
            <div class="container col-md-12 col-sm-12 col-xs-12" style="padding: 0px; margin-top:15px"
                *ngFor="let sectionItr of patientFields.sections  ; let sectionIndex=index">
                <h5>{{sectionItr.sectionName}}</h5>
                <div *ngFor="let sectionCustomFieldItr of sectionItr.customFields  ; let sectionCustomFieldIndex=index">
                    <div class="col-md-4 col-sm-12 col-xs-12" style="margin-top:10px">
                        <div class="chiller_cb">
                            <input id="id_{{sectionCustomFieldItr.id}}" [(ngModel)]="sectionCustomFieldItr.isSelected"
                                name="id_{{sectionCustomFieldItr.id}}" type="checkbox" (click)="preventDeselect($event, sectionCustomFieldItr)"/>
                            <label style="font-weight: normal;"
                                for="id_{{sectionCustomFieldItr.id}}">{{sectionCustomFieldItr.fieldName}}<label
                                    *ngIf="sectionCustomFieldItr.isMandatory"
                                    style="color:red; padding-left: 0px !important;">*</label></label>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Medical Info Section -->
<div class="row content-body tile-progress bg-white" style="margin-top:10px"
    *ngIf="(medicalInfoFields.customFields.length > 0 || medicalInfoFields.sections.length > 0)">
    <div>
        <div class="chiller_cb">
            <input type="checkbox" id="medicalInfoAll" name="medicalInfoAll" [(ngModel)]="allMedicalInfoFieldSelected"
                (change)="selectAllFields('medical-info')" />
            <label style="font-size: 20px;" for="medicalInfoAll">Medical Info</label>
            <span></span>
        </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12" style="padding-left: 0px;padding-right: 0px;">
        <div *ngFor="let itr of medicalInfoFields.customFields; let fieldIndex=index">
            <div class="col-md-4 col-sm-12 col-xs-12" style="margin-top:10px">
                <div class="chiller_cb">
                    <input id="id_{{itr.id}}" [(ngModel)]="itr.isSelected" name="id_{{itr.id}}" type="checkbox" (click)="preventDeselect($event, itr)"/>
                    <label style="font-weight: normal;" for="id_{{itr.id}}">{{itr.fieldName}}<label
                            *ngIf="itr.isMandatory" style="color:red; padding-left: 0px !important;" >*</label></label>
                    <span></span>
                </div>
            </div>

        </div>
        <div>
            <div class="container col-md-12 col-sm-12 col-xs-12" style="padding: 0px; margin-top:15px"
                *ngFor="let sectionItr of medicalInfoFields.sections  ; let sectionIndex=index">
                <h5>{{sectionItr.sectionName}}</h5>
                <div *ngFor="let sectionCustomFieldItr of sectionItr.customFields  ; let sectionCustomFieldIndex=index">
                    <div class="col-md-4 col-sm-12 col-xs-12" style="margin-top:10px">
                        <div class="chiller_cb">
                            <input id="id_{{sectionCustomFieldItr.id}}" [(ngModel)]="sectionCustomFieldItr.isSelected"
                                name="id_{{sectionCustomFieldItr.id}}" type="checkbox" (click)="preventDeselect($event, sectionCustomFieldItr)"/>
                            <label style="font-weight: normal;"
                                for="id_{{sectionCustomFieldItr.id}}">{{sectionCustomFieldItr.fieldName}}<label
                                    *ngIf="sectionCustomFieldItr.isMandatory"
                                    style="color:red; padding-left: 0px !important;">*</label></label>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Refraction fields section -->
<div class="row content-body tile-progress bg-white"
    *ngIf="(refractionFields.customFields.length > 0 || refractionFields.sections.length > 0)">
    <div>
        <div class="chiller_cb">
            <input type="checkbox" id="refractionAll" name="refractionAll" [(ngModel)]="allRefractionFieldsSelected"
                (change)="selectAllFields('refraction')" />
            <label style="font-size: 20px;" for="refractionAll">Refraction</label>
            <span></span>
        </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12" style="padding-left: 0px;padding-right: 0px;">

        <div *ngFor="let itr of refractionFields.customFields; let fieldIndex=index">
            <div class="col-md-4 col-sm-12 col-xs-12" style="margin-top:10px">
                <div class="chiller_cb">
                    <input id="id_{{itr.id}}" [(ngModel)]="itr.isSelected" name="id_{{itr.id}}" type="checkbox"
                        checked="itr.isMandatory" (click)="preventDeselect($event, itr)"/>
                    <label style="font-weight: normal;" for="id_{{itr.id}}">{{itr.fieldName}}<label
                            *ngIf="itr.isMandatory" style="color:red; padding-left: 0px !important;">*</label></label>
                    <span></span>
                </div>
            </div>

        </div>
        <div>
            <div class="container col-md-12 col-sm-12 col-xs-12" style="padding: 0px; margin-top:15px"
                *ngFor="let sectionItr of refractionFields.sections  ; let sectionIndex=index">
                <h5>{{sectionItr.sectionName}}</h5>
                <div *ngFor="let sectionCustomFieldItr of sectionItr.customFields  ; let sectionCustomFieldIndex=index">
                    <div class="col-md-4 col-sm-12 col-xs-12" style="margin-top:10px">
                        <div class="chiller_cb">
                            <input id="id_{{sectionCustomFieldItr.id}}" [(ngModel)]="sectionCustomFieldItr.isSelected"
                                name="id_{{sectionCustomFieldItr.id}}" type="checkbox" (click)="preventDeselect($event, sectionCustomFieldItr)"/>
                            <label style="font-weight: normal;"
                                for="id_{{sectionCustomFieldItr.id}}">{{sectionCustomFieldItr.fieldName}}<label
                                    *ngIf="sectionCustomFieldItr.isMandatory"
                                    style="color:red; padding-left: 0px !important;">*</label></label>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div style="text-align: center; margin-bottom:20px" *ngIf="(patientFields.customFields.length > 0 || patientFields.sections.length > 0) || (medicalInfoFields.customFields.length > 0 || medicalInfoFields.sections.length > 0) || (refractionFields.customFields.length > 0 || refractionFields.sections.length > 0)">
    <button class="btn btn-sm btn-success" (click)="downloadExcel()">
        <i class="fa fa-fw fa-lg fa-download"></i> Download Excel </button>
</div>